import { Link } from '@inertiajs/react'
import Navbar from '@/components/layout/Navbar'
import EpisodeCard from '@/components/ui/EpisodeCard'
import type { EpisodeCard as EpisodeCardType } from '@/types'

interface Props {
  tag: { name: string; slug: string; count: number }
  episodes: EpisodeCardType[]
}

export default function Show({ tag, episodes }: Props) {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <div className="max-w-5xl mx-auto px-4 py-10">
        <Link href="/episodes" className="text-sm text-gray-400 hover:text-gray-600 mb-3 block">← All episodes</Link>
        <div className="flex items-baseline gap-3 mb-8">
          <h1 className="text-3xl font-bold text-gray-900 capitalize">{tag.name}</h1>
          <span className="text-gray-400 text-lg">{tag.count} episodes</span>
        </div>
        {episodes.length > 0 ? (
          <div className="grid md:grid-cols-3 gap-6">
            {episodes.map((ep, i) => <EpisodeCard key={ep.id} episode={ep} index={i} />)}
          </div>
        ) : (
          <div className="text-center py-20 text-gray-400">No episodes tagged with "{tag.name}" yet.</div>
        )}
      </div>
    </div>
  )
}
